import React from 'react'
import PropTypes from 'prop-types'
import TagList from '#components/m/TagList'
import ManageAbteilungenButton from './ManageAbteilungenButton'

function ManageAbteilungenTagList({currentUserId, abteilungen, refreshAbteilungen}) {
  const tags = abteilungen.map(a => ({
    name: a.name,
    color: a.backgroundColor,
    contrastingTextColor: a.textColor,
    variant: 'fill',
  }))

  return (
    <TagList
      tags={tags}
      suffix={ManageAbteilungenButton({
        currentUserId,
        abteilungen,
        refreshAbteilungen
      })}
    />
  )
}

ManageAbteilungenTagList.propTypes = {
  currentUserId: PropTypes.number.isRequired,
  abteilungen: PropTypes.arrayOf(
    PropTypes.shape({
      id: PropTypes.number.isRequired,
    }),
  ),
  refreshAbteilungen: PropTypes.func.isRequired,
}

export default ManageAbteilungenTagList
